'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dibsBrowserStorage = require('dibs-browser-storage');

var _dibsBrowserStorage2 = _interopRequireDefault(_dibsBrowserStorage);

var _visitCountConstants = require('./visitCountConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VisitCountModel = function () {
    function VisitCountModel() {
        _classCallCheck(this, VisitCountModel);

        this.data = {
            totalVisitCount: 0,
            session: 0,
            sinceRegPrompt: 0,
            regPromptLimit: _visitCountConstants.VISITS_PER_SESSION_LOGIN_PROMPT,
            pseudoSessionExpiration: _visitCountConstants.PSEUDO_SESSION_EXPIRES_AT,
            gaSessionPageCount: 0,
            priorPagePdp: 0,
            gaTrackerEventFired: 0
        };

        if (_dibsBrowserStorage2.default.localStorage) {
            this.parseIntStorageData(_visitCountConstants.KEY_STORAGE);
            this.parseIntStorageData(_visitCountConstants.KEY_PSEUDO_SESSION_STORAGE);

            if (this.isPseudoSessionExpired()) {
                this.data = {
                    session: 0,
                    regPromptLimit: _visitCountConstants.VISITS_PER_SESSION_LOGIN_PROMPT,
                    gaSessionPageCount: 0,
                    priorPagePdp: 0,
                    gaTrackerEventFired: 0
                };
            }
        }
    }

    /**
     * checks to see if time stamp on "session" storage has expired
     * @returns {boolean}
     */


    _createClass(VisitCountModel, [{
        key: 'isPseudoSessionExpired',
        value: function isPseudoSessionExpired() {
            var limit = this.data.pseudoSessionExpiration;
            var now = new Date().getTime();
            // if no timestamp assume it's brand new
            return now - (this.data.pseudoTimeStamp || now) >= limit;
        }

        /**
         * fetches an object from local storage and parses its fields to integers
         * @param key {string} the key in local storage
         */

    }, {
        key: 'parseIntStorageData',
        value: function parseIntStorageData(key) {
            var _this = this;

            var source = _dibsBrowserStorage2.default.localStorage;

            var data = source.getItem(key) || {};

            // parseInt over all fields
            Object.keys(data).forEach(function (field) {
                var values = parseInt(data[field], 10) || 0;
                _this.set(field, values);
            });
        }

        /**
         * gets value from class object
         *  @param field {string} - class object property
         *  @returns object property
         */

    }, {
        key: 'get',
        value: function get(field) {
            return this.data[field];
        }

        /**
         * sets value to class object
         * @params field {string}
         * @params value {number}
         */

    }, {
        key: 'set',
        value: function set(field, value) {
            this.data[field] = value;
        }

        /**
        * increments tracking related visitor model values
        */

    }, {
        key: 'incrementTracking',
        value: function incrementTracking() {
            var _this2 = this;

            var incrementValues = ['session', 'totalVisitCount', 'sinceRegPrompt', 'gaSessionPageCount'];
            incrementValues.forEach(function (value) {
                _this2.increment(value);
            });
        }

        /**
         * increments a field by 1
         * @param field {string}
         */

    }, {
        key: 'increment',
        value: function increment(field) {
            var val = this.get(field) || 0;
            this.set(field, val + 1);
        }

        /**
         * saves visit counts to local and session storage
         */

    }, {
        key: 'save',
        value: function save() {
            var localData = {
                totalVisitCount: this.get('totalVisitCount'),
                sinceRegPrompt: this.get('sinceRegPrompt'),
                regPromptLimit: this.get('regPromptLimit')
            };

            _dibsBrowserStorage2.default.localStorage.setItem(_visitCountConstants.KEY_STORAGE, localData);

            var pseudoSessionData = {
                session: this.get('session'),
                pseudoTimeStamp: new Date().getTime(),
                gaSessionPageCount: this.get('gaSessionPageCount'),
                priorPagePdp: this.get('priorPagePdp'),
                gaTrackerEventFired: this.get('gaTrackerEventFired')
            };

            _dibsBrowserStorage2.default.localStorage.setItem(_visitCountConstants.KEY_PSEUDO_SESSION_STORAGE, pseudoSessionData);
        }

        /**
         * removes visit counts from session and local storage
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            _dibsBrowserStorage2.default.localStorage.deleteItem(_visitCountConstants.KEY_STORAGE);
            _dibsBrowserStorage2.default.localStorage.deleteItem(_visitCountConstants.KEY_PSEUDO_SESSION_STORAGE);
        }
    }]);

    return VisitCountModel;
}();

exports.default = VisitCountModel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-visit-tracking/dist/visitCountModel.js
// module id = ./node_modules/dibs-visit-tracking/dist/visitCountModel.js
// module chunks = 4